import React from 'react';

import getGames from '../SearchSelect/facades/getGames.facade';
import SearchSelect from '../SearchSelect/SearchSelect';

function GameSearchSelect({
    currentTitle,
    onChange,
}) {
    function handleGameSelect(data) {
        onChange({
            alias: 'game',
            ...data,
        });
    }

    return (
        <SearchSelect
            label={currentTitle ? `Игра: ${currentTitle}` : 'Игра'}
            fetchFn={getGames}
            onChange={handleGameSelect}
        />
    );
}

export default GameSearchSelect;
